function resolveAuthManager(app) {

    if (app && typeof app.getAuthManager === 'function')
        return app.getAuthManager();

    return null;

}

export async function openFileContentInNewWindow(fileUid, fileContentUrl, app, handleError) {

    if (!fileUid) {
        handleError?.('Soubor nebyl nalezen.');
        return false;
    }

    if (!fileContentUrl) {
        handleError?.('Nepodařilo se připravit odkaz na soubor.');
        return false;
    }

    const popupWindow = window.open('', '_blank');
    const authManager = resolveAuthManager(app);

    app?.setBusyFlag?.();

    try {

        if (popupWindow) {
            popupWindow.opener = null;
        }

        if (
            authManager
            && typeof authManager.refresh === 'function'
            && typeof authManager.isCookieMode === 'function'
            && !authManager.isCookieMode()
        ) {
            await authManager.refresh();
        }

        if (popupWindow && !popupWindow.closed) {
            popupWindow.location.href = fileContentUrl;
        } else {
            window.open(fileContentUrl, '_blank', 'noopener,noreferrer');
        }

        return true;

    } catch (error) {

        if (popupWindow && !popupWindow.closed && typeof popupWindow.close === 'function')
            popupWindow.close();

        handleError?.(error);
        return false;

    } finally {

        app?.clearBusyFlag?.();

    }

}
